module.exports = __webpack_public_path__ + "img/content-img-3.c1065a3f.jpg";